export const bypassAuthHeader = {
    'x-bypass-auth': '0A0qnipTqSQyI1FsKkra2Q83qpeQiUZ1dAF82DeLhNbLkTItXbnNmCD5lsQXFbG5'
};